export default "__VITE_ASSET__xt$Ug42m__"